import React from 'react'
import SquareButton from 'ui/buttons/SquareButton'
import { Translation } from '@morningtrain/react-translations'

export default function WeekDaySelector (props) {
  const setActiveWeekday = (weekDay) => {
    if (typeof props.onSelect === 'function') {
      props.onSelect(weekDay)
    }
  }

  const isInactive = weekDay => props.activeWeekday !== weekDay

  return (
    <div className='flex justify-between group space-x-1'>
      <SquareButton onClick={() => setActiveWeekday(1)} color='btn-lightgray' inactive={isInactive(1)}>
        <Translation name='generic.weekdays.short.monday' />
      </SquareButton>
      <SquareButton onClick={() => setActiveWeekday(2)} color='btn-lightgray' inactive={isInactive(2)}>
        <Translation name='generic.weekdays.short.tuesday' />
      </SquareButton>
      <SquareButton onClick={() => setActiveWeekday(3)} color='btn-lightgray' inactive={isInactive(3)}>
        <Translation name='generic.weekdays.short.wednesday' />
      </SquareButton>
      <SquareButton onClick={() => setActiveWeekday(4)} color='btn-lightgray' inactive={isInactive(4)}>
        <Translation name='generic.weekdays.short.thursday' />
      </SquareButton>
      <SquareButton onClick={() => setActiveWeekday(5)} color='btn-lightgray' inactive={isInactive(5)}>
        <Translation name='generic.weekdays.short.friday' />
      </SquareButton>
      <SquareButton onClick={() => setActiveWeekday(6)} color='btn-lightgray' inactive={isInactive(6)}>
        <Translation name='generic.weekdays.short.saturday' />
      </SquareButton>
      <SquareButton onClick={() => setActiveWeekday(0)} color='btn-lightgray' inactive={isInactive(0)}>
        <Translation name='generic.weekdays.short.sunday' />
      </SquareButton>
    </div>
  )
}
